/**
 * @file stage-color.ts
 * @description Проверка цвета стадии, который задал магазин (phase19.31,
 * SC28): сделки, заказы и возвраты показывают его только точкой — через
 * CSS-переменную `--badge-dot` или фон кружка.
 *
 * Значение приходит из настроек магазина и попадает прямо в `style`, поэтому
 * пропускаем только hex (`#abc`, `#aabbcc`, `#aabbccdd`). Всё прочее —
 * `url(...)`, `red; background:…`, пустое — отбрасываем: точка рисуется
 * цветом тона стадии.
 */

/** Цвет магазина годится для точки только как hex: прочее в стиль не пускаем. */
export function safeStageColor(color: string | null | undefined): string | null {
  return color && /^#[0-9a-f]{3,8}$/i.test(color) ? color : null;
}
